"use client";

import { useRouter } from "next/navigation";
import { FC, type JSX } from "react";

export const BackButton: FC<JSX.IntrinsicElements["button"]> = ({
  onClick: handleClick,
  children,
  ...rest
}) => {
  const { back } = useRouter();
  return (
    <button
      onClick={(e) => {
        if (handleClick) handleClick(e);
        back();
      }}
      {...rest}
    >
      {children}
    </button>
  );
};
